// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__28S_F","productName":"Table_productName__BZj2e"};